import { Button, Form, Icon, Row, Col, message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { FaWhatsapp } from "react-icons/fa";

import InputMask from "~/components/UI/InputMask";
import * as whatsappByDepartmentActions from "./actions";
import CollapsibleSection from "../components/CollapsibleSection";

var FormCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 20px 24px;
  .ant-form-item { margin-bottom: 16px; }
  .ant-form-item:last-child { margin-bottom: 0; }
  .ant-form-item-label { line-height: 1.5; padding-bottom: 4px; }
  .ant-form-item-label label { font-size: 13px; font-weight: 500; color: #595959; }
  .ant-input { border-radius: 6px; }
`;

var inputMaskProps = {
  mask: "(99) 9999tt999?",
  formatChars: { "9": "[0-9]", t: "[0-9-]", "?": "[0-9 ]" },
  maskChar: null,
  placeholder: "(00) 00000-0000",
};

var departments = [
  { key: 'legalization', label: 'Legalização', icon: 'audit' },
  { key: 'administrative', label: 'Administrativo', icon: 'solution' },
  { key: 'accounting', label: 'Contábil', icon: 'calculator' },
  { key: 'fiscal', label: 'Fiscal', icon: 'file-protect' },
  { key: 'personal', label: 'Pessoal', icon: 'team' },
  { key: 'audit', label: 'Sucesso do Cliente', icon: 'customer-service' },
];

export var WhatsappByDepartment = Form.create()(function(props) {
  var form = props.form;
  var dispatch = useDispatch();
  var user = useSelector(function(state) { return state.user; });
  var savingState = useState(false);
  var isSaving = savingState[0];
  var setIsSaving = savingState[1];

  var getFieldDecorator = form.getFieldDecorator;
  var validateFields = form.validateFields;
  var setFieldsValue = form.setFieldsValue;

  useEffect(function() {
    if (!user) return;
    var tenant = user.tenant;
    setFieldsValue({
      legalization: tenant.legalization_phone,
      administrative: tenant.administrative_phone,
      accounting: tenant.accounting_phone,
      fiscal: tenant.fiscal_phone,
      personal: tenant.personal_phone,
      audit: tenant.audit_phone,
    });
  }, [user]);

  var handleSubmit = function() {
    validateFields(function(error, values) {
      if (error) return;
      setIsSaving(true);
      dispatch(whatsappByDepartmentActions.savePhonesByDepartment(values))
        .then(function() { message.success('Números salvos com sucesso!'); })
        .catch(function(err) { console.log(err); })
        .finally(function() { setIsSaving(false); });
    });
  };

  return React.createElement(CollapsibleSection, {
    title: 'WhatsApp por Departamento',
    description: 'Número de WhatsApp exibido para cada departamento no portal do cliente',
    icon: React.createElement(FaWhatsapp, { style: { fontSize: 16 } }),
    bg: '#f6ffed',
    color: '#52c41a'
  },
    React.createElement(Form, { layout: 'vertical' },
      React.createElement(FormCard, null,
        React.createElement(Row, { gutter: 16 },
          departments.map(function(dept) {
            return React.createElement(Col, { span: 12, key: dept.key },
              React.createElement(Form.Item, {
                label: React.createElement('span', null,
                  React.createElement(Icon, { type: dept.icon, style: { marginRight: 6, color: '#52c41a' } }),
                  dept.label
                )
              },
                getFieldDecorator(dept.key)(
                  React.createElement(InputMask, inputMaskProps)
                )
              )
            );
          })
        ),
        React.createElement('div', { style: { display: 'flex', justifyContent: 'flex-end', marginTop: 8 } },
          React.createElement(Button, {
            type: 'primary', icon: 'save', loading: isSaving,
            onClick: handleSubmit
          }, 'Salvar')
        )
      )
    )
  );
});
